export interface Testimonial {
  q: string;
  n: string;
  r: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    q: "We went from 200 to over 2,000 Instagram followers in 60 days — and our bookings doubled. RevSpike didn't just post content, they built us a system.",
    n: "Sarah M.",
    r: "Salon Owner, Toronto",
  },
  {
    q: "They made us look like a real brand, not just a restaurant. The short-form videos bring people in every single week. Best investment we've made.",
    n: "James R.",
    r: "Restaurant Owner, Vancouver",
  },
  {
    q: "I didn't have to think about marketing anymore. RevSpike handles everything and the results speak for themselves. We're fully booked most weekends now.",
    n: "Marcus T.",
    r: "Barbershop Owner, Calgary",
  },
];
